// Feign Death's "Trigger an allied minion's Deathrite."
//
// Fire the picked minion's on_death (Deathrite) automation WITHOUT the
// minion leaving play. Reuses the exact applyCardAutomation dispatch
// that fireDeathriteOnLeave uses, so a Deathrite resolves identically
// to a real death. Except the minion stays on the board. Because the
// minion is still in host.meshes, positional scope resolution finds its
// live cell directly (no position snapshot needed, unlike the leave-play
// path). Pure orchestration over the host adapter.

/**
 * Trigger `minion`'s Deathrite in-band. No-op if it has no on_death
 * automation. Returns true if a Deathrite was fired.
 * @param {object} host   GameBoard adapter (applyCardAutomation, _getFullCard)
 * @param {object} minion live minion instance (stays in play)
 */
export function triggerTargetDeathrite(host, minion) {
  if (!minion) return false;
  const fullCard = host._getFullCard(minion.cardId);
  const entries = fullCard?.automation || [];
  if (!entries.some((e) => e.trigger === 'on_death')) return false;
  host.applyCardAutomation(minion, ['on_death']);
  return true;
}
